import ColorPicker from "@components/miscellany/color_picker/color_picker"
import store from '../../../../edit/store'

export default function ColorPickerComponent(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this

    let colorPicker

    this.generate = () =>{
        let current_color = store.getProgressBarOptionsNestedProp('options.color')
        if(!current_color){
            current_color = 'red'
            store.setProgressBarOptionsNestedProp('options.color', current_color) //default
        }
        elements.container = this.createElement('div')
        elements.picker = this.createElement('div')
        elements.label = this.createElement('label', '', 'Cor')
        
        colorPicker = new ColorPicker({container:elements.picker, current_color: (current_color)})
        colorPicker.generate()

        colorPicker.on('change', data =>{
            store.setProgressBarOptionsNestedProp('options.color', data.color.toHEXA().toString())
        })

        $(elements.container).append(elements.label, elements.picker)
        $(container).append(elements.container)
    }

    this.update = () =>{

    }
}

ColorPickerComponent.prototype = Object.create(BaseConstructor.prototype)